// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"90":"c131c72b","354":"7a8a8c00","463":"94d713e9","464":"2d3c0aef","515":"01c57873","583":"f6418d9b","614":"412109d2","633":"a8cded99","751":"ecb8750a","868":"952bbea4","898":"083dc5c3"}[chunkId] + ".chunk.js";
};